<template>  
  <div class="home">
    <div class="top">
      <van-popup v-model="confirmAppointShow" position="bottom" get-container="body" :style="{ height: '50%', width: '100%' }"
    :closeable="true">
    <div class="">
      <div class="plr20 bggrey ft28" style="height: 7vh; line-height: 7vh">
        确认预约
      </div>
      <div class="flex alcenter between" style="margin: 5px; height: 20vh;">        
        <van-field label-align="center"  v-model="selectedStationInfo.stationName" required label="上车站点" placeholder="请选择上车站点" :is-link="true" readonly @click="showStationSelect=true"/>
         <van-action-sheet
          title="请选择上车站点"
          style="height: 50vh;"
          v-model:show="showStationSelect"
          :actions="stations"
          show-toolbar
          @close="showStationSelect = false"
          @select="onSelectStation"
        />
      </div>      
      <div style="display: flex; justify-content: space-around" class="flex w80">
        <van-button type="primary" style="text-align: center;" class="flex w40 tc" @click="confirmAppointBus()">确认预约</van-button>
        <van-button type="danger" style="text-align: center;" class="flex w40 tc" @click="confirmAppointShow = false">关闭</van-button>
      </div>
    </div>
  </van-popup>
      <tabs @tabChange="initContent" :list="list">
        <div slot="current">
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker show-toolbar :columns="columns" value-key="roomName" @cancel="showPicker = false"
              @confirm="onConfirm" />
          </van-popup>
          <!-- <div style="">
            <p class="tips">*开车前15分钟不能预约</p>
          </div> -->
          <van-pull-refresh v-model="isLoading1" @refresh="onRefresh1">
            <div class="autoFixed">
              <van-list>
                <van-cell v-for="(item, index) in needAuditing" :key="index"
                  style="margin-bottom: 10px; padding: 0; border-radius: 5px">
                  <div class="" style="position: relative; padding-bottom: 20px">
                    <div style="
                        border-bottom: 1px solid #eee;
                        padding: 10px 0 10px 10px;
                      ">
                      <span class="" style="
                          font-weight: bold;
                          color: #64b0ff;
                          font-weight: bold;
                        ">{{ item.routeName }}</span>
                    </div>
                    <div class="history-left" style="margin-top: 10px">

                      <div style="margin-left: 10px; margin-bottom: 10px">
                        <span>发车地点：</span>
                        <span>{{ item.startStation }}</span>
                      </div>

                      <div style="margin-left: 10px; margin-bottom: 10px">
                        <span>发车时间：</span>
                        <span>{{ item.startTime }}</span>
                      </div>

                      <div style="margin-left: 10px; margin-bottom: 10px">
                        <span>已预约人数：</span>
                        <span>{{ item.appointCount }}</span>
                      </div>      
                      <div style="">
                        <p class="tips">预约截止时间：{{ item.stopBookTime }}</p>
                      </div>                
                    </div>
                    <!-- 审核中 -->
                    <div class="hisotry-right">
                      <!-- <img
                        v-if="item.shiftStatus == 0"
                        src="../../assets/auditing/daishenhe.png"
                      /> -->
                      <!-- 同意 -->
                    </div>

                    <van-button plain type="info" size="small" class="userBtn" ref="sureBtn"
                      v-if="item.appointCount < item.loadCount" @click="showCurrentReason(item)">预约
                    </van-button>
                    <van-button plain type="info" size="small" class="userBtn redBtn" ref="sureBtn " v-else>预约已满
                    </van-button>
                    <van-button plain type="info" size="small" class="countBtn" ref="sureBtn"
                       @click="showStationCount(item)">预约人数
                    </van-button>
                  </div>
                </van-cell>
                <!-- 加载的内容-->
              </van-list>
            </div>
          </van-pull-refresh>
        </div>

        <!-- =================历史记录-===================== -->
        <div slot="history">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="autoFixed">
              <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
                <van-cell v-for="(item, index) in histroyLists" :key="index"
                  style="margin-bottom: 10px; padding: 0; border-radius: 5px">
                  <div class="main">
                    <span class="roomName">{{ item.routeName }}</span>
                    <div class="history-left" style="margin-top: 20px">
                      <div class="history-item">
                        <span>发车地点：</span>
                        <span>{{ item.startStation }}</span>
                      </div>
                      <div class="history-item">
                        <span>发车时间：</span>
                        <span>{{ item.startTime }}</span>
                      </div>
                      <div class="history-item">
                        <span>预约站点：</span>
                        <span>{{ item.stationName }}</span>
                      </div>
                      <div v-if="item.personName" class="history-item">
                        <span>司机姓名：</span>
                        <span>{{ item.personName }}</span>
                      </div>
                      <div v-if="item.personPhone" class="history-item">
                        <span>司机电话：</span>
                        <span>{{ item.personPhone }}</span>
                      </div>
                      <div v-if="item.busNo" class="history-item">
                        <span>车牌号：</span>
                        <span>{{ item.busNo }}</span>
                      </div>                      
                      <div class="history-item">
                        <span>已预约人数：</span>
                        <span>{{ item.appointCount }}</span>
                      </div>
                    </div>

                    <div class="hisotry-right cc">
                      <img v-if="item.checkStatus == 0" src="../../assets/sushe/yuyuezhong.png" alt="" />
                      <img v-if="item.checkStatus == 1" src="../../assets/auditing/wancheng.png" alt="" />
                      <!-- 驳回 -->
                      <img v-if="item.checkStatus == 9" src="../../assets/sushe/quxiao.png" alt="" />
                    </div>
                    <van-button plain type="info" size="small" class="userBtn" @click="cancleAppointment(item)"
                      v-if="item.checkStatus == 0">取消
                    </van-button>
                  </div>
                </van-cell>
                <!-- 加载的内容-->
              </van-list>
            </div>
          </van-pull-refresh>
        </div>
      </tabs>
      <van-popup v-model="detailStationCountShow" get-container="body" :style="{ height: '80%', width: '90%' }" :closeable="true">
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 8vh; line-height: 8vh">
           {{detailRouteName}} 预约详情
          </div>
          <van-cell-group class="plr20">
            
            <van-cell v-for="(detail, index) in stationAppoints" :key="index" :title="detail.stationName" :value="detail.appointCount" />
                        
          </van-cell-group>

          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="detailStationCountShow = false">关闭</van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import tabs from "../../components/tabs.vue";
import {
  getRoutersLists,
  historyCarsLists,
  preAudting,
  addCarsPreOrder,
  getBusRouterStations,//查询路线站点详情
  cancleRouter,
  stationApptCount,//查询站点预约人数
} from "../../apis/api";
import { Toast, Dialog, ActionSheet } from "vant";
import { formatTime, getCurrentDate } from "../../utils/index";
export default {
  data() {
    return {
      show: false,
      list: [
        {
          name: "当前路线",
          type: "current",
        },
        {
          name: "历史预约",
          type: "history",
        },
      ],
      isLoading1: false,
      isLoading: false,
      loading: false,
      isShow: false,
      roomLists: [],
      showConfirm: false,
      columns: [1, 2, 3],
      showPicker: false,
      histroyLists: [],
      beginTime: "",
      endTime: "",
      date: "",
      pageSize: 10,
      pageNo: 1,
      needAuditing: [],
      finishedBottom: false,
      stations: [],//站点列表
      selectedStationInfo: {stationName:'请选择'},//选择的站点
      confirmAppointShow: false,
      showStationSelect: false,//站点选择弹框
      vehicleShift:{},//当前选择的班次
      stationAppoints:[],//站点的预约人数
      detailStationCountShow: false,//站点详情弹框
      detailRouteName: "",//当前选择的路线名称
    };
  },
  beforeDestroy() {
    clearInterval(this.setTimer);
    this.setTimer = null;
  },
  mounted() {
    document.title = "坐车预约";

    let _this = this;

    this.getCurrentLists();
  },

  methods: {
    cancleAppointment(item) {
      cancleRouter({ id: item.id }).then((res) => {
        // Toast(res.message);
        this.pageSize = 10;
        this.pageNo = 1;
        historyCarsLists({
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }).then((res) => {
          this.isLoading = false;
          this.histroyLists = res.result.records;
        });
      });
    },
    onLoad() {
      console.log("加载更多");
      this.pageNo++;
      historyCarsLists({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        // Toast("刷新成功");
        this.isLoading = false;
        this.loading = false;
        this.histroyLists = this.histroyLists.concat(res.result.records);
        if (this.histroyLists.length == this.total) {
          this.finishedBottom = true;
        }
      });
      this.finishedBottom = true;
    },

    beforeDay(num) {
      //设置日期，当前日期的前num天
      var myDate = new Date(); //获取今天日期
      // myDate.setDate(myDate.getDate() - (num - 1));
      var dateArray = [];

      var dateTemp;
      var flag = 1;
      dateTemp =
        myDate.getFullYear() -
        1 +
        "-" +
        (myDate.getMonth() + 1) +
        "-" +
        myDate.getDate();
      dateArray.push(dateTemp);
      myDate.setDate(myDate.getDate() + flag);
      return dateArray;
    },
    getCurrentLists() {
      getRoutersLists({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.needAuditing = res.result.records;
        this.isLoading1 = false;
      });
    },

    initContent(value) {
      console.log("init", value);
      if (value == 0) {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getCurrentLists();
      } else {
        historyCarsLists({
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }).then((res) => {
          console.log("history", res);
          if (res.result.records.length == 0) {
            Toast("暂无数据");
          } else {
            this.histroyLists = res.result.records;
          }
        });
      }
    },
    onConfirm(e) {
      console.log(e);
      this.showPicker = false;
      this.texts = e.roomName;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    calendarConfirm(e) {
      console.log(e);
      this.show = false;
      const [start, end] = e;
      this.show = false;
      this.isShow = true;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.beginTime = this.formatDate(start);
      this.endTime = this.formatDate(end);
    },
    showStationCount(item){
      this.detailRouteName=item.routeName
      stationApptCount({
        shiftId: item.id
      }).then((res) => {
        console.log(res);
        this.stationAppoints = res.result;    
        this.detailStationCountShow=true;   
      });
    },
    showCurrentReason(item) {
      this.vehicleShift=item;
      getBusRouterStations({
        routeId: item.routeId,
      }).then((res) => {
        console.log(res);
        this.stations = res.result; //站点列表
          if(this.stations && this.stations.length>0)
          {
            //给this.stations添加属性值，方便后续使用
            this.stations.forEach(item => {
               item.name = item.stationName;
            });
            this.selectedStationInfo=this.stations[0];//默认选择第一个站点
             this.confirmAppointShow = true;
          }

      });
    },
  
    onSelectStation(e){
        this.showStationSelect=false;
        this.selectedStationInfo = e;
    },
    confirmAppointBus() {
      addCarsPreOrder({
        id: this.vehicleShift.id,
        stationId: this.selectedStationInfo.uid,
      }).then((res) => {
        console.log(res);
        Toast(res.message);
        //刷新页面
        this.getCurrentLists();
        this.confirmAppointShow = false;
      });
    },

    onCancel(index) {
      this.$refs.reasons[index].style.display = "none";
      this.$refs.cancleBtn[index].style.display = "none";
      this.$refs.sureBtn[index].style.display = "block";
    },
    onChange() { },
    onRefresh1() {
      this.getCurrentLists();
    },
    onRefresh() {
      this.pageSize = 10;
      this.pageNo = 1;
      // this.getHistoryLists();
      historyCarsLists({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.histroyLists = res.result.records;
      });
    },
  },
  components: {
    tabs,
  },
};
</script>

<style lang="less" scoped>
.labels {
  width: 80px;

  //   border-right: 1px solid #eee;
  p {
    width: 100%;
    text-align: center;
    height: 80px;
    line-height: 80px;
    border-bottom: 1px solid #eee;
  }

  p:last-child {
    //   border-bottom: none;
  }
}

.autoFlex {
  display: flex;
}

.roomList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-left: 1px solid #eee;
  flex: 1;

  .room {
    width: 13.9%;
    border-right: 1px solid #eee;
    height: 80px;
    border-bottom: 1px solid #eee;
    text-align: center;
    line-height: 80px;
  }

  .room:nth-child(7n) {
    border-right: none;
  }
}

.level_room {
  h4 {
    width: 100%;
    text-align: center;
    color: #489fff;
    border-top: 1px solid #489fff;
    border-bottom: 1px solid #489fff;
    margin: 0;
    height: 80px;
    line-height: 80px;
    font-size: 40px;
    // margin-top: 20px;
  }
}

.lists {
  display: flex;

  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #eee;
  }

  .lasts {
    border: none;
  }
}

.borders {
  border: 1px solid #eee;
  margin: 0 auto;
  margin-left: 30px;
  // padding-top: 10px;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;

  // padding: 10px 20px;
  .left {
    border-right: 1px solid #eee;
    padding: 20px 10px;
    padding-bottom: 0;
    width: 9.5%;
  }

  .right {
    border-left: 1px solid #eee;
    padding: 20px 10px;
    padding-bottom: 0;
    width: 9.5%;
  }

  .arrows {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;

    img {
      width: 40px;
      height: 40px;
    }
  }
}

.currentPre {
  width: 80%;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.selects {
  width: 50%;
  margin: 0 auto;
  border: 2px solid #489fff;
  border-radius: 80px;
  margin-top: 20px;
  height: 60px;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  position: relative;
}

.icons {
  font-size: 32px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.selects h3 {
  font-size: 28px;
  height: 60px;
  line-height: 60px;
  margin: 0;
  color: #489fff;
  text-align: center;
  // color: ;
}

.autoFixed {
  padding: 30px;
  padding-bottom: 0;
  padding-top: 0;
  position: relative;

  .userBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 140px;
    height: 40px;
    text-align: center;
    line-height: 40px;

    background: none;
    border-radius: 5px;
    color: #4597ff;
  }

  .countBtn {
    position: absolute;
    right: 20px;
    top: 80px;
    width: 140px;
    height: 40px;
    text-align: center;
    line-height: 40px;

    background: none;
    border-radius: 5px;
    color: #4597ff;
  }

  .main {
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    padding: 30px;
    box-sizing: border-box;
    position: relative;
    padding-top: 60px;
    // margin-top: 20px;
    padding-bottom: 0;

    // margin-bottom: 20px;
    .roomName {
      position: absolute;
      left: 20px;
      top: 20px;
      color: #64b0ff;
      font-weight: bold;
    }

    .history-item {
      margin-bottom: 20px;

      span {
        font-size: 28px;
        color: #333;
      }

      span:nth-child(1) {
        font-weight: 700;
      }
    }
  }
}

.currentPre {
  display: flex;
  height: 80px;
  align-items: center;
  width: 80%;
  margin: 0 auto;
  border: 2px solid #7ab6f5;
  margin-top: 20px;
  border-radius: 40px;
  justify-content: center;
  background-color: #ffffff;
  margin-bottom: 20px;

  span {
    font-size: 32px;
    color: #7ab6f5;
    margin-right: 20px;
  }

  .fontss {
    font-size: 32px;
    color: #7ab6f5;
    margin-right: 20px;
  }

  i {
    font-size: 40px;
    color: #7ab6f5;
  }
}

.place {
  display: flex;
  align-items: center;
  justify-content: center;
}

.home {
  background: #f7f7f7;
  min-height: 100vh;
}

.demo {
  display: flex;
  align-items: center;
}

.demo span {
  font-size: 24px;
}

.disableds {
  background: #d0d0d0;
}

.flexLayout {
  display: flex;
  align-items: center;
}

.cc img {
  width: 150px;
  height: 130px !important;
}

.hisotry-right {
  position: absolute;
  right: 10px;
  bottom: 120px;

  img {
    width: 150px;
    height: 150px;
  }
}

.tips {
  color: #f40;
  font-size: 24px;
  padding: 10px 10px;
}

.redBtn {
  background: #f40 !important;
  border: none;
  color: #ffffff !important;
  width: 160px !important;
}
</style>
